module.exports = __webpack_public_path__ + "76bb351a3b7fb52e259ba1959b6192d0.png";